// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after{ box-sizing:border-box; }

.pf-wrap{
  background:var(--card);
  border:1px solid var(--border);
  border-radius:var(--radius);
  box-shadow:var(--shadow);
  padding:18px;
  display:grid;
  gap:14px;
  max-width:100%;
}

.pf-head{
  display:flex; align-items:center; justify-content:space-between;
}
.pf-head h2{ margin:0; font-size:22px; color:var(--text); }

.pf-iconBtn{
  border:1px solid var(--border);
  background:var(--card);
  color:var(--muted);
  width:36px;height:36px;border-radius:12px;
  display:grid;place-items:center; cursor:pointer;
  box-shadow:0 6px 12px rgba(15,23,42,.08);
}
.pf-iconBtn:hover{ color:var(--text); background:var(--primary-ghost); }
.pf-iconBtn:disabled{ opacity:.55; cursor:not-allowed; }
.pf-iconBtn.danger{ color:var(--danger); border-color:#fecaca; }

.pf-card{
  border:1px solid var(--border);
  border-radius:16px;
  padding:14px;
  background:var(--card);
}
.pf-card__head{
  display:flex;align-items:center;justify-content:space-between;margin-bottom:10px;
}
.pf-card__title{ display:flex;align-items:center;gap:.55rem;font-weight:800;color:var(--text); }
.pf-card__titleIcon{ color:var(--primary); }
.pf-card--editing{ box-shadow:0 0 0 4px var(--ring); border-color:#b9d4ff; }

.pf-basics{ display:grid; grid-template-columns:140px minmax(0,1fr); gap:16px; align-items:start; }
.pf-avatar{ display:grid; gap:10px; justify-items:center; }
.pf-avatar img{ width:110px; height:110px; border-radius:999px; object-fit:cover; border:3px solid #dbeafe; }
.pf-avatar__ph{
  width:110px;height:110px;border-radius:999px;display:grid;place-items:center;
  background:linear-gradient(180deg,#eaf2ff,#ffffff);
  color:#94a3b8; font-size:42px; border:3px solid #dbeafe;
}

.pf-grid{ display:grid; gap:12px; }
@media (min-width:760px){
  .pf-grid{ grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:14px 16px; }
}
.pf-podFields{ display:grid; gap:12px; }

.pf-ro{ display:grid; gap:4px; min-width:0; }
.pf-label{ font-size:12px; color:var(--muted); }
.pf-value{
  padding:10px 12px; border:1px dashed var(--border); border-radius:12px; background:#f8fbff;
  max-width:100%;
  white-space:normal;
  overflow-wrap:anywhere;
  word-break:break-word;
}
.pf-muted{ color:var(--muted); }
.pf-secretRow{
  display:grid;
  grid-template-columns:minmax(0,1fr) auto;
  gap:8px;
  align-items:center;
}
.pf-secretValue{
  font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.pf-roBlock{
  border:1px dashed var(--border); border-radius:12px; padding:10px 12px; color:var(--text);
  max-width:100%;
  white-space:normal;
  overflow-wrap:anywhere;
  word-break:break-word;
}

.pf-input, .pf-textarea{
  width:100%; border:1px solid var(--border); border-radius:12px;
  padding:10px 12px; background:var(--card); color:var(--text); outline:none; min-width:0;
}
.pf-input:disabled{
  background:#f8fbff;
  border:1px dashed var(--border);
  color:var(--primary);
}
.pf-input:focus, .pf-textarea:focus{
  border-color:#b9d4ff; box-shadow:0 0 0 4px var(--ring);
}
.pf-textarea{ min-height:84px; resize:vertical; }

.pf-cols{ display:grid; gap:16px; }
@media (min-width:760px){ .pf-cols{ grid-template-columns:minmax(0,1fr) minmax(0,1fr); } }
.pf-subtitle{ font-weight:800; color:var(--text); margin-bottom:6px; display:flex; gap:.5rem; align-items:center;}

.pf-list{ display:grid; gap:8px; }
.pf-listRow{ display:grid; grid-template-columns:minmax(0,1fr) auto; gap:8px; align-items:center; }
.pf-chip{
  display:inline-block; border:1px solid var(--border); background:#f8fbff;
  padding:8px 10px; border-radius:999px; font-size:14px; color:var(--text); margin:4px 4px 0 0;
  max-width:100%;
  white-space:normal;
  overflow-wrap:anywhere;
  word-break:break-word;
}

.pf-btn{
  border:1px solid #c5dbff; background:var(--primary-ghost); color:var(--primary);
  padding:8px 12px; border-radius:14px; font-weight:700; cursor:pointer;
}
.pf-btn.ghost{ background:var(--card); color:var(--primary); }
.pf-btn.primary{ background:linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%); color:#fff; border-color:var(--primary); }
.pf-btn:disabled{ opacity:.6; cursor:not-allowed; }
.pf-actions{ display:flex; justify-content:flex-end; margin-top:4px; }

.pf-iconBtn.danger{ color:var(--danger); }

.pf-toggle{
  display:flex; gap:8px; flex-wrap:wrap; margin-bottom:12px;
}
.pf-toggleBtn{
  border:1px solid var(--border);
  background:var(--card);
  color:var(--text);
  padding:8px 12px;
  border-radius:999px;
  font-weight:700;
  cursor:pointer;
}
.pf-toggleBtn.active{
  background:var(--primary-ghost);
  color:var(--primary);
  border-color:#c5dbff;
  box-shadow:0 0 0 3px var(--ring);
}
.pf-checklist{ display:grid; gap:8px; }
.pf-check{ display:flex; align-items:center; gap:8px; font-weight:600; color:var(--text); }
.pf-check input{ accent-color:var(--primary); }
.pf-privateRegistry{ display:grid; gap:8px; }

.pf-registryGrid{
  display:grid;
  gap:12px;
  grid-template-columns:repeat(auto-fit, 140px);
  justify-content:flex-start;
}
.pf-registryCard{
  position:relative;
  border:1px solid var(--border);
  background:#f8fbff;
  border-radius:16px;
  padding:8px;
  cursor:pointer;
  transition:transform .12s ease, box-shadow .12s ease, border-color .12s ease;
  box-shadow:0 8px 16px rgba(15,23,42,.08);
  width:140px;
}
.pf-registryCard:hover{
  transform:translateY(-1px);
  border-color:#c5dbff;
  box-shadow:0 10px 18px rgba(15,23,42,.12);
}
.pf-registryCard.selected{
  border-color:var(--primary);
  box-shadow:0 0 0 3px var(--ring), 0 12px 20px rgba(15,23,42,.12);
  background:#ffffff;
}
.pf-registryImage{
  display:grid;
  place-items:center;
  background:#fff;
  border-radius:12px;
  border:1px solid #e2e8f0;
  aspect-ratio:1/1;
  width:100%;
  height:auto;
  padding:6px;
  overflow:hidden;
}
.pf-registryImage img{
  max-width:90%;
  max-height:90%;
  object-fit:contain;
}
.pf-registryIcon{
  font-size:42px;
  color:#1d4ed8;
}
.pf-registryCheck{
  position:absolute;
  top:10px;
  right:10px;
  width:28px;
  height:28px;
  border-radius:999px;
  display:grid;
  place-items:center;
  font-weight:800;
  background:#ffffff;
  color:var(--primary);
  border:2px solid #c5dbff;
  opacity:0;
  transform:scale(.9);
  transition:opacity .12s ease, transform .12s ease;
}
.pf-registryCard.selected .pf-registryCheck{
  opacity:1;
  transform:scale(1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile.css"],"names":[],"mappings":"AAAA,wBAAwB,qBAAqB,EAAE;;AAE/C;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY,EAAE,kBAAkB,EAAE,6BAA6B;AACjE;AACA,aAAa,QAAQ,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAE1D;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,UAAU,CAAC,WAAW,CAAC,kBAAkB;EACzC,YAAY,CAAC,kBAAkB,EAAE,cAAc;EAC/C,wCAAwC;AAC1C;AACA,mBAAmB,iBAAiB,EAAE,+BAA+B,EAAE;AACvE,sBAAsB,WAAW,EAAE,kBAAkB,EAAE;AACvD,oBAAoB,mBAAmB,EAAE,oBAAoB,EAAE;;AAE/D;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,kBAAkB;AAClF;AACA,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,UAAU,CAAC,eAAe,CAAC,iBAAiB,EAAE;AAC/F,qBAAqB,oBAAoB,EAAE;AAC3C,mBAAmB,gCAAgC,EAAE,oBAAoB,EAAE;;AAE3E,YAAY,YAAY,EAAE,yCAAyC,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AAClG,YAAY,YAAY,EAAE,QAAQ,EAAE,oBAAoB,EAAE;AAC1D,gBAAgB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AAC5G;EACE,WAAW,CAAC,YAAY,CAAC,mBAAmB,CAAC,YAAY,CAAC,kBAAkB;EAC5E,kDAAkD;EAClD,aAAa,EAAE,cAAc,EAAE,wBAAwB;AACzD;;AAEA,UAAU,YAAY,EAAE,QAAQ,EAAE;AAClC;EACE,UAAU,iDAAiD,EAAE,aAAa,EAAE;AAC9E;AACA,eAAe,YAAY,EAAE,QAAQ,EAAE;;AAEvC,QAAQ,YAAY,EAAE,OAAO,EAAE,WAAW,EAAE;AAC5C,WAAW,cAAc,EAAE,kBAAkB,EAAE;AAC/C;EACE,iBAAiB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,kBAAkB;EAC1F,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;AACA,WAAW,kBAAkB,EAAE;AAC/B;EACE,YAAY;EACZ,wCAAwC;EACxC,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,8GAA8G;AAChH;AACA;EACE,+BAA+B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,iBAAiB;EACzF,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,UAAU,EAAE,8BAA8B,EAAE,kBAAkB;EAC9D,iBAAiB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,YAAY,EAAE,WAAW;AACzF;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,oBAAoB,EAAE,gCAAgC;AACxD;AACA,cAAc,eAAe,EAAE,eAAe,EAAE;;AAEhD,UAAU,YAAY,EAAE,QAAQ,EAAE;AAClC,0BAA0B,UAAU,iDAAiD,EAAE,EAAE;AACzF,cAAc,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,YAAY,EAAE,SAAS,EAAE,kBAAkB,CAAC;;AAEjH,UAAU,YAAY,EAAE,OAAO,EAAE;AACjC,aAAa,YAAY,EAAE,wCAAwC,EAAE,OAAO,EAAE,kBAAkB,EAAE;AAClG;EACE,oBAAoB,EAAE,8BAA8B,EAAE,kBAAkB;EACxE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB;EAC5F,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB,EAAE,+BAA+B,EAAE,oBAAoB;EAC/E,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,cAAc;AACvE;AACA,eAAe,sBAAsB,EAAE,oBAAoB,EAAE;AAC7D,iBAAiB,4DAA4D,EAAE,UAAU,EAAE,2BAA2B,EAAE;AACxH,kBAAkB,UAAU,EAAE,kBAAkB,EAAE;AAClD,aAAa,YAAY,EAAE,wBAAwB,EAAE,cAAc,EAAE;;AAErE,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,YAAY,EAAE,OAAO,EAAE,cAAc,EAAE,kBAAkB;AAC3D;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;AAClC;AACA,eAAe,YAAY,EAAE,OAAO,EAAE;AACtC,WAAW,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC1F,iBAAiB,2BAA2B,EAAE;AAC9C,qBAAqB,YAAY,EAAE,OAAO,EAAE;;AAE5C;EACE,YAAY;EACZ,QAAQ;EACR,6CAA6C;EAC7C,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,4EAA4E;EAC5E,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,yCAAyC;AAC3C;AACA;EACE,2BAA2B;EAC3B,gEAAgE;EAChE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,SAAS;EACT,kBAAkB;AACpB","sourcesContent":["*, *::before, *::after{ box-sizing:border-box; }\n\n.pf-wrap{\n  background:var(--card);\n  border:1px solid var(--border);\n  border-radius:var(--radius);\n  box-shadow:var(--shadow);\n  padding:18px;\n  display:grid;\n  gap:14px;\n  max-width:100%;\n}\n\n.pf-head{\n  display:flex; align-items:center; justify-content:space-between;\n}\n.pf-head h2{ margin:0; font-size:22px; color:var(--text); }\n\n.pf-iconBtn{\n  border:1px solid var(--border);\n  background:var(--card);\n  color:var(--muted);\n  width:36px;height:36px;border-radius:12px;\n  display:grid;place-items:center; cursor:pointer;\n  box-shadow:0 6px 12px rgba(15,23,42,.08);\n}\n.pf-iconBtn:hover{ color:var(--text); background:var(--primary-ghost); }\n.pf-iconBtn:disabled{ opacity:.55; cursor:not-allowed; }\n.pf-iconBtn.danger{ color:var(--danger); border-color:#fecaca; }\n\n.pf-card{\n  border:1px solid var(--border);\n  border-radius:16px;\n  padding:14px;\n  background:var(--card);\n}\n.pf-card__head{\n  display:flex;align-items:center;justify-content:space-between;margin-bottom:10px;\n}\n.pf-card__title{ display:flex;align-items:center;gap:.55rem;font-weight:800;color:var(--text); }\n.pf-card__titleIcon{ color:var(--primary); }\n.pf-card--editing{ box-shadow:0 0 0 4px var(--ring); border-color:#b9d4ff; }\n\n.pf-basics{ display:grid; grid-template-columns:140px minmax(0,1fr); gap:16px; align-items:start; }\n.pf-avatar{ display:grid; gap:10px; justify-items:center; }\n.pf-avatar img{ width:110px; height:110px; border-radius:999px; object-fit:cover; border:3px solid #dbeafe; }\n.pf-avatar__ph{\n  width:110px;height:110px;border-radius:999px;display:grid;place-items:center;\n  background:linear-gradient(180deg,#eaf2ff,#ffffff);\n  color:#94a3b8; font-size:42px; border:3px solid #dbeafe;\n}\n\n.pf-grid{ display:grid; gap:12px; }\n@media (min-width:760px){\n  .pf-grid{ grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:14px 16px; }\n}\n.pf-podFields{ display:grid; gap:12px; }\n\n.pf-ro{ display:grid; gap:4px; min-width:0; }\n.pf-label{ font-size:12px; color:var(--muted); }\n.pf-value{\n  padding:10px 12px; border:1px dashed var(--border); border-radius:12px; background:#f8fbff;\n  max-width:100%;\n  white-space:normal;\n  overflow-wrap:anywhere;\n  word-break:break-word;\n}\n.pf-muted{ color:var(--muted); }\n.pf-secretRow{\n  display:grid;\n  grid-template-columns:minmax(0,1fr) auto;\n  gap:8px;\n  align-items:center;\n}\n.pf-secretValue{\n  font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n.pf-roBlock{\n  border:1px dashed var(--border); border-radius:12px; padding:10px 12px; color:var(--text);\n  max-width:100%;\n  white-space:normal;\n  overflow-wrap:anywhere;\n  word-break:break-word;\n}\n\n.pf-input, .pf-textarea{\n  width:100%; border:1px solid var(--border); border-radius:12px;\n  padding:10px 12px; background:var(--card); color:var(--text); outline:none; min-width:0;\n}\n.pf-input:disabled{\n  background:#f8fbff;\n  border:1px dashed var(--border);\n  color:var(--primary);\n}\n.pf-input:focus, .pf-textarea:focus{\n  border-color:#b9d4ff; box-shadow:0 0 0 4px var(--ring);\n}\n.pf-textarea{ min-height:84px; resize:vertical; }\n\n.pf-cols{ display:grid; gap:16px; }\n@media (min-width:760px){ .pf-cols{ grid-template-columns:minmax(0,1fr) minmax(0,1fr); } }\n.pf-subtitle{ font-weight:800; color:var(--text); margin-bottom:6px; display:flex; gap:.5rem; align-items:center;}\n\n.pf-list{ display:grid; gap:8px; }\n.pf-listRow{ display:grid; grid-template-columns:minmax(0,1fr) auto; gap:8px; align-items:center; }\n.pf-chip{\n  display:inline-block; border:1px solid var(--border); background:#f8fbff;\n  padding:8px 10px; border-radius:999px; font-size:14px; color:var(--text); margin:4px 4px 0 0;\n  max-width:100%;\n  white-space:normal;\n  overflow-wrap:anywhere;\n  word-break:break-word;\n}\n\n.pf-btn{\n  border:1px solid #c5dbff; background:var(--primary-ghost); color:var(--primary);\n  padding:8px 12px; border-radius:14px; font-weight:700; cursor:pointer;\n}\n.pf-btn.ghost{ background:var(--card); color:var(--primary); }\n.pf-btn.primary{ background:linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%); color:#fff; border-color:var(--primary); }\n.pf-btn:disabled{ opacity:.6; cursor:not-allowed; }\n.pf-actions{ display:flex; justify-content:flex-end; margin-top:4px; }\n\n.pf-iconBtn.danger{ color:var(--danger); }\n\n.pf-toggle{\n  display:flex; gap:8px; flex-wrap:wrap; margin-bottom:12px;\n}\n.pf-toggleBtn{\n  border:1px solid var(--border);\n  background:var(--card);\n  color:var(--text);\n  padding:8px 12px;\n  border-radius:999px;\n  font-weight:700;\n  cursor:pointer;\n}\n.pf-toggleBtn.active{\n  background:var(--primary-ghost);\n  color:var(--primary);\n  border-color:#c5dbff;\n  box-shadow:0 0 0 3px var(--ring);\n}\n.pf-checklist{ display:grid; gap:8px; }\n.pf-check{ display:flex; align-items:center; gap:8px; font-weight:600; color:var(--text); }\n.pf-check input{ accent-color:var(--primary); }\n.pf-privateRegistry{ display:grid; gap:8px; }\n\n.pf-registryGrid{\n  display:grid;\n  gap:12px;\n  grid-template-columns:repeat(auto-fit, 140px);\n  justify-content:flex-start;\n}\n.pf-registryCard{\n  position:relative;\n  border:1px solid var(--border);\n  background:#f8fbff;\n  border-radius:16px;\n  padding:8px;\n  cursor:pointer;\n  transition:transform .12s ease, box-shadow .12s ease, border-color .12s ease;\n  box-shadow:0 8px 16px rgba(15,23,42,.08);\n  width:140px;\n}\n.pf-registryCard:hover{\n  transform:translateY(-1px);\n  border-color:#c5dbff;\n  box-shadow:0 10px 18px rgba(15,23,42,.12);\n}\n.pf-registryCard.selected{\n  border-color:var(--primary);\n  box-shadow:0 0 0 3px var(--ring), 0 12px 20px rgba(15,23,42,.12);\n  background:#ffffff;\n}\n.pf-registryImage{\n  display:grid;\n  place-items:center;\n  background:#fff;\n  border-radius:12px;\n  border:1px solid #e2e8f0;\n  aspect-ratio:1/1;\n  width:100%;\n  height:auto;\n  padding:6px;\n  overflow:hidden;\n}\n.pf-registryImage img{\n  max-width:90%;\n  max-height:90%;\n  object-fit:contain;\n}\n.pf-registryIcon{\n  font-size:42px;\n  color:#1d4ed8;\n}\n.pf-registryCheck{\n  position:absolute;\n  top:10px;\n  right:10px;\n  width:28px;\n  height:28px;\n  border-radius:999px;\n  display:grid;\n  place-items:center;\n  font-weight:800;\n  background:#ffffff;\n  color:var(--primary);\n  border:2px solid #c5dbff;\n  opacity:0;\n  transform:scale(.9);\n  transition:opacity .12s ease, transform .12s ease;\n}\n.pf-registryCard.selected .pf-registryCheck{\n  opacity:1;\n  transform:scale(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
